import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { getReservationsByProductType } from 'utils/helpers';
import { useCurrentBookingState } from 'utils/hooks/use_current_booking_state';
import AmountToPay from 'components/checkout_form/amout_to_pay';
import PromoCodeWithLink from 'components/promo_code/with_link';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import Accommodation from './accommodation';
import { ExperiencesCard } from './experiences';
import Ferry from './ferry';

const showSectionFunction =
  (isBookingComplete, isDraft) => (reservationType, booking) => {
    let show = window.ecom.craftConfig.features[reservationType];

    if (isDraft) {
      show = show && reservationType === 'ferry';
    } else if (isBookingComplete) {
      // For some tenants, reservationType is not 'ferry' but 'unscheduledFerry'
      const reservations = getReservationsByProductType(
        reservationType === 'ferry'
          ? 'ferry,unscheduledFerry'
          : reservationType,
        booking
      );
      show = show && !isEmpty(reservations);
    }

    return show;
  };

const BookingSummary = () => {
  const currentBooking = useSelector(getCurrentBooking);

  const { isFullyPaid: isBookingComplete, isDraft } = useCurrentBookingState();
  const showSection = showSectionFunction(isBookingComplete, isDraft);

  return (
    <div className="booking-summary space-y-4">
      {/* Ferry */}
      {showSection('ferry', currentBooking) && <Ferry />}

      {/* Accommodation */}
      {showSection('accommodation', currentBooking) && <Accommodation />}

      {/* Experiences */}
      {showSection('experience', currentBooking) && <ExperiencesCard />}

      {!isBookingComplete && <PromoCodeWithLink />}
      <div className="d-lg-none">
        <hr />
        <AmountToPay />
      </div>
    </div>
  );
};

export default BookingSummary;
